module.exports = __webpack_public_path__ + "static/img/return.ee7ae3ad.svg";